import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { baseUrl, customHeaders, umsUrl, adminAPIURL } from '../../../../../Containers/Config/index.js';
import { GET_MEMBERSHIP_BY_USER, GET_MEMBERSHIP_BY_USER_SUCCESS, GET_MEMBERSHIP_BY_USER_ERROR } from '../../actions.js';
import apiCall from '../../../apiCall.js';

function* getMembershipByUser({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];
    const { userId } = payload.data;

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/admin/user/${userId}/memberships`,
      method: 'GET',
      headers: {
        // Authorization: Constant?.CLIENT_TOKEN,
        ...filteredHeaders,
        // withCredentials: true
      },
      params: payload?.urlParams,
    });

    if (response.status === 200) {
      yield put({
        type: GET_MEMBERSHIP_BY_USER_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_MEMBERSHIP_BY_USER_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_MEMBERSHIP_BY_USER_ERROR, payload: error });
  }
}

export function* watchGetMembershipByUser() {
  yield takeEvery(GET_MEMBERSHIP_BY_USER, getMembershipByUser);
}

function* getMembershipByUserSaga() {
  yield all([fork(watchGetMembershipByUser)]);
}

export default getMembershipByUserSaga;
